import React from 'react';
import { postRecruitmentMessageData, updateRecruitmentMessageData } from '../../service/adminApi';
import { OnlyNumber, OnlyNumberSpecialChar, OnlySpecialChar } from '../../utils/RegHandling';
import { uploadBackend } from '../../utils/Upload';

function RegistrationForm({ editData, handleData, messageType, hideContainer }) {
    const attachment = React.useRef();
    let defaultValue = {
        title: '',
        description: '',
        attachment_url: '',
    };
    let errorDefaultValue = {
        titleError: '',
        descriptionError: '',
        fileNameError: '',
    };
    const [type, setType] = React.useState();
    const [registrationMessageDetails, setRegistrationMessage] = React.useState(defaultValue);
    const [registrationMessageError, setRegistrationMessageError] = React.useState(errorDefaultValue);
    const [editId, setEditId] = React.useState();
    const [attachmentFileName, setAttachmentFileName] = React.useState('');
    const [attachmentValidation, setattachmentValidation] = React.useState('');
    const [showNavbar, setShowNavbar] = React.useState(false);
    React.useEffect(() => {
        if (editData !== undefined) {
            

            setRegistrationMessage({
                title: editData.title,
                description: editData.description,
                attachment_url: editData.attachment_url,
            });
            if (editData.attachment_url !== '') {
                let data = editData.attachment_url?.split('/');
                if (data?.length > 0) {
                    data = data[data?.length - 1];
                    setAttachmentFileName(data);
                }
            }
            setEditId(editData.id);
        }
    }, [editData]);

    React.useEffect(() => {
        if (messageType !== 'undefined') {
            setType(messageType);
        }
    }, [messageType]);

    const resetData = () => {
        setRegistrationMessage(defaultValue);
        setEditId();
        setRegistrationMessageError(errorDefaultValue);
        handleData('cancel');
        hideContainer();
        setAttachmentFileName('');
        if (type == 'registration' && attachment?.current.value != '') attachment.current.value = '';
    };

    const handleRecruitmentMessageForm = (e) => {
        setShowNavbar(true);
        setRegistrationMessage((registrationMessage) => ({
            ...registrationMessage,
            [e.target.name]: e.target.value,
        }));
    };

    {

    }

    const postRecruitmentMessage = async () => {
        
        let dirName = `Registration-Message`;
        if (validateRecruitmentForm()) {
            setShowNavbar(true);
            let data = {};
            if (editId === undefined || editId === '') {
                if (type === 'registration' && attachmentValidation == '') {
                    data = registrationMessageDetails;
                    data['message_type'] = messageType;
                    let file = attachment.current.files[0];
                    let newFileName = attachment.current.files[0].name;
                    const uploadAttachment = await uploadBackend(file, newFileName,dirName);
                    if (uploadAttachment.location !== undefined) {
                        data['attachment_url'] = uploadAttachment;
                    }
                } else {
                    data['title'] = registrationMessageDetails.title;
                    data['description'] = registrationMessageDetails.description;
                    data['message_type'] = messageType;
                    data['attachment_url'] = '';
                }
                const response = await postRecruitmentMessageData(data);
                if (response.data.statusCode === 200) {
                    setRegistrationMessage(defaultValue);
                    handleData('update');
                    hideContainer();
                }
            } else {
                let data = registrationMessageDetails;
                data['id'] = editId;
                data['message_type'] = messageType;
                data['attachment_url'] = registrationMessageDetails.attachment_url;
                // if (attachmentFileName === undefined) {
                //     data['attachment_url'] = '';
                // }

                if (type === 'registration' && attachmentValidation == '') {
                    data = registrationMessageDetails;
                    data['message_type'] = messageType;
                    let file = attachment.current.files[0];
                    if (file !== undefined) {
                        let newFileName = attachment.current.files[0].name;
                        const uploadAttachment = await uploadBackend(file, newFileName,dirName);
                        if (uploadAttachment.location !== undefined) {
                            data['attachment_url'] = uploadAttachment;
                        }
                    }
                } else {
                    data['title'] = registrationMessageDetails.title;
                    data['description'] = registrationMessageDetails.description;
                    data['message_type'] = messageType;
                    data['attachment_url'] = '';
                }

                const reponse = await updateRecruitmentMessageData(data);
                if (reponse.data.statusCode === 200) {
                    setRegistrationMessage(defaultValue);
                    handleData('update');
                    hideContainer();
                }
            }
        }
    };

    const validateRecruitmentForm = () => {
        setShowNavbar(false);
        let validate = true;
        if (registrationMessageDetails.title === undefined || registrationMessageDetails.title === '') {
            let error = '';
            if (type == 'registration') {
                error = 'Registration Name is required';
            } else {
                error = 'Rejection Name is required';
            }
            setRegistrationMessageError((offboardingTemplateErrors) => ({
                ...offboardingTemplateErrors,
                nameError: error,
            }));
            validate = false;
        }
        if (OnlyNumberSpecialChar(registrationMessageDetails.title)) {
            setRegistrationMessageError((offboardingTemplateErrors) => ({
                ...offboardingTemplateErrors,
                nameError: 'Enter a valid Title',
            }));
            validate = false;
        }
        if (registrationMessageDetails.description === undefined || registrationMessageDetails.description === '') {
            let error = '';
            if (type == 'registration') {
                error = 'Registration Description is required';
            } else {
                error = 'Rejection Description is required';
            }
            setRegistrationMessageError((offboardingTemplateErrors) => ({
                ...offboardingTemplateErrors,
                descriptionError: error,
            }));
            validate = false;
        }
        if (messageType == 'registration' && attachmentValidation == '') {
            if (!attachment.current.files.length > 0) {
                setRegistrationMessageError((offboardingTemplateErrors) => ({
                    ...offboardingTemplateErrors,
                    fileNameError: 'Attachment is required',
                }));
                validate = false;
            }
        }
        return validate;
    };

    const addFileName = (e) => {
        setAttachmentFileName(e.target.files[0].name);
        setRegistrationMessageError((offboardingTemplateErrors) => ({
            ...offboardingTemplateErrors,
            fileNameError: '',
        }));
        if (e.target.files[0].size >= 1000000) {
            setattachmentValidation('File size should be less than 1MB');
            attachment.current.value = '';
            return false;
        } else {
            setattachmentValidation('');
        }
        const typeArr = ['jpg', 'png', 'svg+xml', 'jpeg', 'svg'];
        let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
        if (type == false) {
            setattachmentValidation('The uploaded file should be in JPG, PNG, JPEG, SVG format');
            attachment.current.value = '';
            return false;
        } else {
            setattachmentValidation('');
        }
    };

    const removeAttachment = () => {
        setAttachmentFileName('');
        attachment.current.value = '';
        setattachmentValidation('');
    };

    return (
        <>
            <div className="offcanvas-header">
                <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                    {editData.title == undefined ? (type == 'registration' ? `Registration Message` : 'Rejection Message') : `Edit Message`}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    // data-bs-dismiss="offcanvas"
                    // aria-label="Close"
                    onClick={() => {
                        resetData();
                    }}
                />
            </div>
            <div className="offcanvas-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <label className="form-label font-12 bold-text announcement-offcanvas-color" htmlFor="Announcement-Title">
                                    Title
                                    <span class="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control custom-textfield regular-text font-13"
                                    id="Announcement-Title"
                                    placeholder="Registration Text"
                                    name="title"
                                    value={registrationMessageDetails.title}
                                    maxLength={30}
                                    onChange={(e) => {
                                        setRegistrationMessageError((registrationMessageError) => ({
                                            ...registrationMessageError,
                                            nameError: '',
                                        }));
                                        handleRecruitmentMessageForm(e);
                                    }}
                                />
                                {registrationMessageError.nameError !== undefined || registrationMessageError.nameError !== '' ? (
                                    <span className="text-danger fs-6">{registrationMessageError.nameError}</span>
                                ) : null}
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="form-label font-12 bold-text  announcement-offcanvas-color" htmlFor="Announcement-Title">
                                    Description
                                    <span class="hive-form-mandatory">*</span>
                                </label>
                                <textarea
                                    className="form-control custom-textfield regular-text font-13 custom-comment-box"
                                    id="Announcement-Title"
                                    placeholder="Enter here"
                                    name="description"
                                    maxLength={255}
                                    value={registrationMessageDetails.description}
                                    onChange={(e) => {
                                        setRegistrationMessageError((registrationMessageError) => ({
                                            ...registrationMessageError,
                                            descriptionError: '',
                                        }));
                                        handleRecruitmentMessageForm(e);
                                    }}
                                />
                                {registrationMessageError.descriptionError !== undefined ||
                                    registrationMessageError.descriptionError !== '' ? (
                                    <span className="text-danger fs-6">{registrationMessageError.descriptionError}</span>
                                ) : null}
                            </div>

                            {type === 'registration' ? (
                                <div className="col-md-4 mb-4">
                                    <div>
                                        <label className="form-label hive-form-label w-100 font-12 bold-text">
                                            Attach Image <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <label htmlFor="voterid-upload" className="custom-file-upload-styles">
                                            <img className="me-2" src="/Images/top-up.svg" alt="Upload Icon" />
                                            Upload
                                        </label>
                                        <input
                                            onChange={(e) => {
                                                addFileName(e);
                                            }}
                                            id="voterid-upload"
                                            ref={attachment}
                                            className="custom-file-upload-btn"
                                            type="file"
                                        />
                                        <div>
                                            {registrationMessageError.fileNameError !== undefined ||
                                                registrationMessageError.fileNameError !== '' ? (
                                                <span className="text-danger fs-6">{registrationMessageError.fileNameError}</span>
                                            ) : null}

                                            {attachmentValidation ? <span className="text-danger fs-6">{attachmentValidation}</span> : null}
                                        </div>
                                    </div>
                                    {attachmentFileName.length > 0 ? (
                                        <span className="text-primary ms-2">
                                            {attachmentFileName}
                                            <img
                                                onClick={() => {
                                                    removeAttachment();
                                                }}
                                                src="/Images/icon-close.png"
                                            />
                                        </span>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                        <div className="d-flex justify-content-end mb-4 mt-5 p-0 custom-button-position ">
                            <button
                                onClick={() => {
                                    resetData();
                                }}
                                className="btn hive-btn-secondary me-3"
                                // data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => {
                                    postRecruitmentMessage();
                                }}
                                style={{ width: '100px' }}
                                className="btn medium-text font-14 primary-button me-3"
                                data-bs-dismiss={showNavbar == true ? 'offcanvas' : 'dummy'}
                                aria-label="Close"
                            >
                                {editData.id == undefined || editData.id == '' ? `Add` : `Update`}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RegistrationForm;
